import React from "react";
import {
  ChevronDown,
  LogOut,
  User as UserIcon,
  Shield,
} from "lucide-react";

/**
 * User menu — avatar trigger + dropdown with profile, security, sign out.
 */
export default function UserMenu({ user, open, onToggle, onSignOut }) {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={onToggle}
        className="inline-flex items-center gap-2 px-1.5 py-1 rounded-md hover:bg-inset transition-colors"
        data-testid="header-user-menu-trigger"
      >
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-tralenex-600 text-white text-[11px] font-semibold">
          {user?.initials}
        </span>
        <span className="hidden md:flex flex-col items-start">
          <span className="text-meta font-semibold text-ink-primary leading-none">
            {user?.name?.split(" ")[0]}
          </span>
          <span className="text-[10px] tracking-[0.06em] uppercase text-ink-secondary leading-none mt-0.5">
            {user?.roleCode}
          </span>
        </span>
        <ChevronDown size={14} className="text-ink-secondary" />
      </button>

      {open && (
        <div
          className="absolute right-0 top-full mt-2 w-[260px] rounded-md border border-border-subtle bg-raised shadow-e3 anim-fade-up"
          data-testid="header-user-menu"
        >
          <div className="px-3 py-3 border-b border-border-subtle">
            <p className="text-sm font-semibold text-ink-primary">{user?.name}</p>
            <p className="text-meta text-ink-secondary">{user?.role}</p>
            <p className="text-meta text-ink-disabled mt-1 truncate">{user?.email}</p>
          </div>
          <ul className="py-1">
            <MenuItem icon={UserIcon} label="Profile" />
            <MenuItem icon={Shield} label="Security & MFA" />
          </ul>
          <div className="border-t border-border-subtle">
            <button
              type="button"
              onClick={onSignOut}
              className="w-full flex items-center gap-2 px-3 py-2 text-sm text-risk-high hover:bg-inset transition-colors"
              data-testid="header-sign-out"
            >
              <LogOut size={14} /> Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function MenuItem({ icon: Icon, label }) {
  return (
    <li>
      <button className="w-full flex items-center gap-2 px-3 py-2 text-sm text-ink-primary hover:bg-inset transition-colors">
        <Icon size={14} className="text-ink-secondary" /> {label}
      </button>
    </li>
  );
}
